import React from "react";
import PropTypes from "prop-types";

import { Heading } from "../Heading";

import styles from "./Modal.scss";

const ModalHeading = ({ children, variant, ...others }) => (
  <div className={styles.heading}>
    <Heading
      tag="h2"
      variants={variant || Heading.Variant.secondary}
      {...others}
    >
      {children}
    </Heading>
  </div>
);

ModalHeading.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  variant: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
};

ModalHeading.defaultProps = {
  variant: "",
};

ModalHeading.Variant = {
  hint: Heading.Variant.secondarySub,
};

ModalHeading.displayName = "Modal.Heading";

export default ModalHeading;
